import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import cx from 'classnames';

import { Field } from '@ontruck/orc';

import style from './style.module.scss';

class DateField extends Component {
  static propTypes = {
    label: PropTypes.string,
    labelClass: PropTypes.string,
    disabled: PropTypes.bool,
    value: PropTypes.any,
    onChange: PropTypes.func,
    intl: PropTypes.any,
    error: PropTypes.string,
    size: PropTypes.string,
    inputClass: PropTypes.string,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.triggerChange = this.triggerChange.bind(this);
    this.parseState = this.parseState.bind(this);

    this.state = {
      ...this.parseState(props.value),
    };
  }

  parseState(value) {
    if (!value) {
      return {
        day: '',
        month: '',
        year: '',
      };
    }

    const date = moment(value);

    const day = date.format('DD');
    const month = date.format('MM');
    const year = date.format('YYYY');

    return {
      day,
      month,
      year,
    };
  }

  triggerChange() {
    const { day = '', month = '', year = '' } = this.state;

    const { onChange } = this.props;

    if (!onChange) {
      return;
    }

    const date =
      year === '' && month === '' && day === ''
        ? null
        : year === '' || month === '' || day === ''
        ? moment(null)
        : moment(`${year}/${month}/${day}`);

    onChange(date);
  }

  handleChange(type) {
    return (value) => {
      this.setState(
        {
          [type]: value,
        },
        this.triggerChange
      );
    };
  }

  render() {
    const { label, disabled, intl, error, size, inputClass, labelClass, className } = this.props;

    const t = intl.messages.components.DateField;

    const { day, month, year } = this.state;

    return (
      <div data-testid="date-field" className={className}>
        <span
          data-testid="date-field__label"
          className={cx(style.label, labelClass, { [style.error]: error })}
        >
          {error ? error : label}
        </span>
        <div className={style.dateField}>
          <div>
            <Field
              id="day"
              name="day"
              className={inputClass || ''}
              label={t.day}
              value={disabled ? '' : day}
              onChange={(e, { value }) => this.handleChange('day')(value)}
              maxLength="2"
              disabled={disabled}
              error={error ? t.day : null}
              size={size || 'L'}
              width="S"
            />
          </div>
          <div>
            <Field
              id="month"
              name="month"
              className={inputClass || ''}
              label={t.month}
              value={disabled ? '' : month}
              onChange={(e, { value }) => this.handleChange('month')(value)}
              maxLength="2"
              disabled={disabled}
              error={error ? t.month : null}
              size={size || 'L'}
              width="S"
            />
          </div>
          <div>
            <Field
              id="year"
              name="year"
              className={inputClass || ''}
              label={t.year}
              value={disabled ? '' : year}
              onChange={(e, { value }) => this.handleChange('year')(value)}
              maxLength="4"
              disabled={disabled}
              error={error ? t.year : null}
              size={size || 'L'}
              width="S"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(DateField);
